<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-12">
          <button_back></button_back>
        </div>
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4 class="text-orange fw-bold">Cargar anexo</h4>
            </div>
            <div class="card-body">
              <div v-if="loading_upload" class="text-center" style="margin-top: 2em">
                <small class="text-muted">Subiendo archivo...</small><br />
                <div class="lds-roller">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div v-else>
                <label>Aliado</label>
                <h4 class="fw-bold text-orange">{{ aliado.nombre_aliado }}</h4>
                <div v-if="!solicitud">
                  <label>Anexo</label>
                  <h4 class="fw-bold text-orange">{{ anexo.tipo_anexo }}</h4>
                  <div class="form-group mt-4 mb-4">
                    <label>Archivo</label>
                    <input @change="on_file_change" type="file" class="form-control" v-if="
                      id_tipo_anexo == 4 ||
                      id_tipo_anexo == 5 ||
                      id_tipo_anexo == 6 ||
                      id_tipo_anexo == 8 ||
                      id_tipo_anexo == 9 ||
                      id_tipo_anexo == 11
                    " accept="image/png, image/jpeg" />
                    <input v-else @change="on_file_change" type="file" class="form-control" />
                  </div>
                  <div v-if="id_tipo_anexo == 10" class="form-group mt-4 mb-4">
                    <label>Fecha de firma del contrato</label>
                    <input v-model="fecha_firma" type="date" class="form-control" />
                  </div>
                  <div v-if="alert_img" class="mt-3 mb-3">
                    <div class="alert alert-warning">
                      <i class="fa fa-exclamation-circle"></i> La imagen que intentas subir tiene dimensiones diferentes a
                      las recomendadas ({{ width }}px x {{ height }}px). ¿Deseas subir de todas formas?
                    </div>
                  </div>
                  <div class="text-end">
                    <router-link v-bind:to="'/aliado/anexos/' + id_aliado" class="btn btn-outline-dark rounded-pill">
                      <i class="bx bx-chevron-left"></i> Cancelar
                    </router-link>
                    <button v-on:click="valida_upload" class="btn btn-success rounded-pill ms-1" :disabled="
                      file == null ||
                      (id_tipo_anexo == 10 && fecha_firma == null)
                    ">
                      Subir <i class="bx bx-upload"></i>
                    </button>
                  </div>
                </div>
                <div v-else>
                  <div class="text-center">
                    <router-link v-bind:to="'/aliado/anexos/' + id_aliado"
                      class="btn btn-outline-dark btn-lg rounded-pill">
                      <i class="bx bx-chevron-left"></i> Regresar
                    </router-link>
                    <br />
                    <router-link v-bind:to="'/nueva_solicitud_pieza/' + id_aliado"
                      class="btn btn-orange btn-lg rounded-pill mt-3">
                      Solicitar piezas <i class="bx bx-send"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import { defineAsyncComponent } from 'vue';
export default {
  name: "Cargar_anexo",
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      loading_upload: false,
      id_aliado: null,
      id_tipo_anexo: null,
      aliado: null,
      anexo: null,
      hay_archivo: false,
      file: null,
      fecha_firma: null,
      solicitud: false,
      alert_img: false,
      width: null,
      height: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_aliado = this.$route.params.id_aliado;
    this.id_tipo_anexo = this.$route.params.id_tipo_anexo;
    this.get_aliado();
  },
  methods: {
    get_aliado: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "aliados/aliado/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliado = response.data.data;
          this.get_anexo();
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_anexo: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(
          this.$base_url +
          "aliados/anexo/" +
          this.id_aliado +
          "/" +
          this.id_tipo_anexo,
          config,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.anexo = response.data.data.anexo;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    on_file_change(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.hay_archivo = false;
        return;
      }
      this.file = files;
      this.hay_archivo = true;
    },
    valida_upload: function () {
      this.hay_archivo = false;
      this.loading_upload = true;

      if (this.id_tipo_anexo == 9 || this.id_tipo_anexo == 8) {

        let vm = this;
        let file = this.file[0];
        let reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = evt => {
          let img = new Image();
          img.onload = () => {
            if (!vm.alert_img) {

              vm.width = 900;
              vm.height = 450;

              if (vm.id_tipo_anexo == 8) {
                vm.width = 200;
                vm.height = 200;
              }

              if (img.width != vm.width || img.height != vm.height) {
                vm.alert_img = true;
                vm.loading_upload = false;
                return false;
              } else {
                vm.upload();
              }
            } else {
              vm.upload();
            }

          }
          img.src = evt.target.result;
        }

        reader.onerror = evt => {
          console.error(evt);
        }
      } else {
        this.upload();
      }


    },
    upload: function () {
      var formData = new FormData();
      formData.append("files", this.file[0]);
      formData.append("token", this.session.token);
      formData.append("id_aliado", this.id_aliado);
      formData.append("id_tipo_anexo", this.id_tipo_anexo);
      formData.append("fecha_firma", this.fecha_firma);
      const vm = this;
      axios
        .post(this.$base_url + "upload/anexo", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status) {
            vm.hay_archivo = false;
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: "Se ha subido el anexo.",
            });
            vm.loading_upload = false;
            if (vm.id_tipo_anexo == 4) {
              vm.solicitud = true;
            } else {
              vm.$router.push("/aliado/anexos/" + vm.id_aliado);
            }
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Ups!",
              text: response.data.message,
            });
            vm.loading_upload = false;
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Ups",
            text: error,
          });
          console.log(error);
          vm.loading_upload = false;
          vm.alert_img = false;
        });
    }
  },
  mounted: function () { },
};
</script>